// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__SS4gZ","containerItemsCenter":"Skeleton_containerItemsCenter__3jvPS"};